<mat-form-field
	hideRequiredMarker
	[class.read-only]="isReadOnly"
	[class.read-only-due-date-picker]="isReadOnly"
	class="rx-due-date-picker-field"
>
    <mat-label [class.read-only-label-no-value]="isReadOnly && !control.value"
        >{{ 'OrderSection.DueDate' | translate }}:
        <span class="mat-mdc-form-field-required-marker" *ngIf="isRequired && control.enabled">&#32;*</span>
    </mat-label>
    <input
        matInput
        [formControl]="control"
        [matDatepicker]="dueDateDatepicker"
        [min]="minimalAvailableDueDate"
        [max]="maxDueDate"
        autocomplete="off"
        [readonly]="true"
        name="dueDateDatepicker"
        [rxIsRequired]="isRequired"
        (click)="dueDateDatepicker.open()"
        [errorStateMatcher]="matcher"
        [class.read-only]="isReadOnly"
    />
    <mat-datepicker-toggle matSuffix [for]="dueDateDatepicker" *ngIf="!isReadOnly">
        <tlk-calendar-icon
            *ngIf="useIntuitiveCalendarIcon"
            matDatepickerToggleIcon
            class="due-datepicker-icon due-datepicker-icon--intuitive"
        ></tlk-calendar-icon>
        <mat-icon
            *ngIf="!useIntuitiveCalendarIcon"
            matDatepickerToggleIcon
            class="due-datepicker-icon"
            svgIcon="calendar_icon"
        ></mat-icon>
    </mat-datepicker-toggle>

    <rx-datepicker #dueDateDatepicker panelClass="rx-auto-due-datepicker-panel-class">
        <!--  mat-datepicker-actions cannot be placed right here -->
    </rx-datepicker>
</mat-form-field>

<ng-template #footer>
    <footer *ngIf="isCancellable">
        <button
            [id]="id + '-cancel-selection'"
            [disabled]="isCancelButtonDisabled"
            tlkButton
            variant="secondary"
            size="s"
            (click)="handleCancelSelection($event)"
        >{{ 'Selector.ClearSelection' | translate }}</button>
    </footer>
</ng-template>
